import tinycolor from 'tinycolor2';
import {createTheme as createMuiTheme} from '@mui/material';

const coral = '#f0645a';
export const darkBlue = '#22384f';
export const dust = '#fff5e6';

const lightenRate = 9.5;
const darkenRate = 14;

export const themeColors = {
  pageBackgroundColor: '#e6e6e6',
  mainBackgroundColor: '#F6F6F6',
  black: '#000000',
  white: '#FFFFFF',
  tan: '#EBE2D4',
  tanMuted: '#969B9B',
  muted: '#A1A1A1',
  coral: '#F0645A',
  purple: '#B04F7D',
  blue: '#5FC8EB',
  yellow: '#FAC81E',
  grey: '#969B9B',
  greyLight: '#EBEBEB',
  green: '#5AD2A0',
  red: '#FF0000',
  amber: '#FFBF00',

  darkGreen: '#3c8d6c',
  darkRed: '#890606',

  chartPurple: '#A876E5',
  backgroundDark: '#18263A',
  backgroundMuted: '#1E3347',
  backgroundHighlight: '#203850',
  backgroundNotification: '#325A7D',

  lightGreen: '#c0ebd9',
  lightPink: '#f2dce7',
  lightYellow: '#ffeaa6',
  lightWarning: '#fff6d9',
  lightAlert: '#ffd9d6',
  lightBlue: '#c4e3ff',
  lightPurple: '#cda3ff',

  midBlue: '#325a7d',
};

// MUI theming with our selected colour theme
// https://github.com/mui/material-ui/issues/13394

export default createMuiTheme({
  // drawerWidth: 73,

  // MuiCssBaseline: {
  //   '@global': {
  //     '*': {
  //       boxSizing: 'border-box',
  //     },
  //     html: {
  //       MozOsxFontSmoothing: 'grayscale',
  //       WebkitFontSmoothing: 'antialiased',
  //       height: '100%',
  //       width: '100%',
  //     },
  //     body: {
  //       height: '100%',
  //     },
  //     '#root': {
  //       height: '100%',
  //     },
  //   },
  // },

  //   MuiSvgIcon: {
  //     colorPrimary: {
  //       color: coral,
  //     },
  //     colorSecondary: {
  //       color: dust,
  //     },
  //   },
  //   MuiPaper: {
  //     rounded: {
  //       borderRadius: '.5em',
  //     },
  //   },
  //   MuiTooltip: {
  //     tooltip: {
  //       fontSize: '1rem',
  //       backgroundColor: coral,
  //     },
  //   },
  //   MuiDialog: {
  //     root: {
  //       topMargin: '240px',
  //       maxHeight: '80%',
  //     },
  //   },
  //   MuiButton: {
  //     text: {
  //       textTransform: 'capitalize',
  //     },
  //     outlined: {
  //       backgroundColor: themeColors.white,
  //     },
  //   },
  //   MuiAvatar: {
  //     root: {
  //       border: `0.1rem solid ${dust}`,
  //     },
  //   },
  //   MuiRadio: {
  //     root: {
  //       color: themeColors.tanMuted,
  //       padding: 2,
  //     },
  //   },
  //   MuiCheckbox: {
  //     root: {
  //       color: themeColors.tanMuted,
  //     },
  //   },
  //   MuiTab: {
  //     root: {
  //       '&:hover': {
  //         color: coral,
  //         opacity: '1.0',
  //       },
  //     },
  //     textColorInherit: {
  //       '&.Mui-selected': {
  //         color: coral,
  //       },
  //     },
  //   },
  // },
  components: {
    MuiRadio: {
      styleOverrides: {
        root: {
          padding: 0.5,
        },
      },
    },
  },
  palette: {
    info: {
      main: themeColors.white,
    },
    // mode: 'dark',
    primary: {
      main: darkBlue,
      light: tinycolor(darkBlue).lighten(lightenRate).toHexString(),
      dark: tinycolor(darkBlue).darken(darkenRate).toHexString(),
      contrastText: dust,
    },
    secondary: {
      main: coral,
      light: tinycolor(coral).lighten(lightenRate).toHexString(),
      dark: tinycolor(coral).darken(darkenRate).toHexString(),
      contrastText: dust,
    },
    common: {
      black: '#000000',
      white: '#FFFFFF',
    },
    text: {
      primary: '#000000',
      secondary: themeColors.backgroundDark,
    },
    background: {
      default: themeColors.mainBackgroundColor,
      paper: themeColors.white,
    },
  },
  typography: {
    fontFamily: 'Inter, sans-serif',
    h1: {
      fontSize: 48,
      fontWeight: 600,
      lineHeight: 1.5,
      color: themeColors.backgroundHighlight,
    },
    h2: {
      fontSize: 36,
      fontWeight: 400,
      lineHeight: 1.5,
      color: themeColors.backgroundHighlight,
    },
    h3: {
      fontSize: 32,
      fontWeight: 400,
      lineHeight: 1.5,
      color: themeColors.backgroundHighlight,
    },
    h4: {
      fontSize: 24,
      fontWeight: 600,
      lineHeight: 1.5,
      color: themeColors.backgroundHighlight,
    },
    h5: {
      fontSize: 18,
      fontWeight: 600,
      lineHeight: 1.5,
      color: themeColors.backgroundHighlight,
    },
    h6: {
      fontSize: 16,
      fontWeight: 500,
      lineHeight: 1.5,
      color: themeColors.backgroundHighlight,
    },
    body1: {
      fontSize: 14,
    },
    body2: {
      fontSize: 14,
    },
    subtitle1: {
      fontSize: 16,
      fontWeight: 500,
      letterSpacing: 0,
      lineHeight: 1.75,
    },
    subtitle2: {
      fontSize: 14,
      fontWeight: 500,
      letterSpacing: 0,
      lineHeight: 1.57,
    },
    caption: {
      fontWeight: 500,
    },
    overline: {
      fontSize: 12,
      fontWeight: 600,
      letterSpacing: 1,
      lineHeight: 1.66,
    },
    button: {
      fontWeight: 500,
      textTransform: 'none',
    },
  },
  shape: {
    borderRadius: 4,
  },
});
